import { UUID } from '@/types';
import { useDatasourceId } from '@/hooks';
import { useGetAvailableChartsQuery } from '@/features/chart-configuration/apiSlice';

export const useGetAvailableChartTypes = (
  seriesId: Maybe<UUID>,
  skip = false,
) => {
  const datasourceId = useDatasourceId();

  return useGetAvailableChartsQuery(
    {
      datasourceId,
      seriesId: seriesId ?? ('' as UUID),
    },
    { skip: !seriesId || skip },
  );
};
